const selectors = ({ store, statuses }) => ({
    getMetrics: (state) => state[store].metrics,
    getRecurringPayments: (state) => state[store].recurring,
    getLoading: (state) => state[store].status === statuses.LOADING,
    getError: (state) => state[store].error,
    getTimeDimension: (state) => state[store].time_dimension
})

export default selectors
